module.exports = __webpack_public_path__ + "img/login.53d6d623.png";